import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "service-price"
};
const _hoisted_2 = {
  class: "explain"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "trans-service-table"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const transServicePrice = ref([{
      sourceLang: '中文',
      targetLang: '英文',
      tranDocPrice: '59',
      tranMedPrice: '90',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '英文',
      targetLang: '中文',
      tranDocPrice: '59',
      tranMedPrice: '90',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '日文',
      tranDocPrice: '100',
      tranMedPrice: '130',
      chobitsPrice: '320',
      femalePrice: '650',
      tranCertPrice: ''
    }, {
      sourceLang: '日文',
      targetLang: '中文',
      tranDocPrice: '100',
      tranMedPrice: '130',
      chobitsPrice: '320',
      femalePrice: '650',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '韩文',
      tranDocPrice: '100',
      tranMedPrice: '130',
      chobitsPrice: '300',
      femalePrice: '500',
      tranCertPrice: ''
    }, {
      sourceLang: '韩文',
      targetLang: '中文',
      tranDocPrice: '100',
      tranMedPrice: '130',
      chobitsPrice: '300',
      femalePrice: '500',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '法语',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '法语',
      targetLang: '中文',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '西班牙语',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '380',
      femalePrice: '760',
      tranCertPrice: ''
    }, {
      sourceLang: '西班牙语',
      targetLang: '中文',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '380',
      femalePrice: '760',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '德语',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '德语',
      targetLang: '中文',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '俄语',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '350',
      femalePrice: '700',
      tranCertPrice: ''
    }, {
      sourceLang: '俄语',
      targetLang: '中文',
      tranDocPrice: '140',
      tranMedPrice: '170',
      chobitsPrice: '350',
      femalePrice: '700',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '意大利文',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '意大利文',
      targetLang: '中文',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '葡萄牙文（巴西）',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '380',
      femalePrice: '760',
      tranCertPrice: ''
    }, {
      sourceLang: '葡萄牙文（巴西）',
      targetLang: '中文',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '380',
      femalePrice: '760',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '阿拉伯语',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '阿拉伯语',
      targetLang: '中文',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '450',
      femalePrice: '900',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '泰语',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '300',
      femalePrice: '460',
      tranCertPrice: ''
    }, {
      sourceLang: '泰语',
      targetLang: '中文',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '300',
      femalePrice: '460',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '印尼语',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '280',
      femalePrice: '560',
      tranCertPrice: ''
    }, {
      sourceLang: '印尼语',
      targetLang: '中文',
      tranDocPrice: '190',
      tranMedPrice: '220',
      chobitsPrice: '280',
      femalePrice: '560',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '越南语',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '230',
      femalePrice: '460',
      tranCertPrice: ''
    }, {
      sourceLang: '越南语',
      targetLang: '中文',
      tranDocPrice: '160',
      tranMedPrice: '190',
      chobitsPrice: '230',
      femalePrice: '460',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '老挝语',
      tranDocPrice: '260',
      tranMedPrice: '290',
      chobitsPrice: '350',
      femalePrice: '700',
      tranCertPrice: ''
    }, {
      sourceLang: '老挝语',
      targetLang: '中文',
      tranDocPrice: '260',
      tranMedPrice: '290',
      chobitsPrice: '350',
      femalePrice: '700',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '柬埔寨语',
      tranDocPrice: '220',
      tranMedPrice: '250',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '柬埔寨语',
      targetLang: '中文',
      tranDocPrice: '220',
      tranMedPrice: '250',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '马来西亚语',
      tranDocPrice: '180',
      tranMedPrice: '210',
      chobitsPrice: '280',
      femalePrice: '560',
      tranCertPrice: ''
    }, {
      sourceLang: '马来西亚语',
      targetLang: '中文',
      tranDocPrice: '180',
      tranMedPrice: '210',
      chobitsPrice: '280',
      femalePrice: '560',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '缅甸语',
      tranDocPrice: '280',
      tranMedPrice: '310',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '缅甸语',
      targetLang: '中文',
      tranDocPrice: '280',
      tranMedPrice: '310',
      chobitsPrice: '300',
      femalePrice: '600',
      tranCertPrice: ''
    }, {
      sourceLang: '中文',
      targetLang: '蒙古语',
      tranDocPrice: '260',
      tranMedPrice: '290',
      chobitsPrice: '400',
      femalePrice: '800',
      tranCertPrice: ''
    }, {
      sourceLang: '蒙古语',
      targetLang: '中文',
      tranDocPrice: '260',
      tranMedPrice: '290',
      chobitsPrice: '400',
      femalePrice: '800',
      tranCertPrice: ''
    }]);
    const transServiceLevel = ref([{
      level: 'servicePrice.text23',
      process: 'servicePrice.text24',
      desc: 'servicePrice.text25'
    }, {
      level: 'servicePrice.text26',
      process: 'servicePrice.text27',
      desc: 'servicePrice.text28'
    }, {
      level: 'servicePrice.text29',
      process: 'servicePrice.text30',
      desc: 'servicePrice.text31'
    }, {
      level: 'servicePrice.text32',
      process: 'servicePrice.text33',
      desc: 'servicePrice.text34'
    }]);
    const arraySpanMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      if (columnIndex === 6) {
        return {
          rowspan: 36,
          colspan: 1
        };
      }
    };
    const tableRowClassName = ({
      row,
      rowIndex
    }) => {
      if ((rowIndex + 1) % 2 === 0) {
        return 'success-row';
      }
      return '';
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('servicePrice.text1')) + "：", 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('servicePrice.text2')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('servicePrice.text5')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('servicePrice.text6')), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
        data: transServicePrice.value,
        "row-class-name": tableRowClassName,
        "span-method": arraySpanMethod,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          align: "center",
          prop: "sourceLang",
          label: "源语言"
        }), _createVNode(_component_el_table_column, {
          align: "center",
          prop: "targetLang",
          label: "目标语言"
        }), _createVNode(_component_el_table_column, {
          align: "center",
          prop: "tranDocPrice",
          label: "文档翻译"
        }), _createVNode(_component_el_table_column, {
          align: "center",
          prop: "tranMedPrice",
          label: "医疗医药翻译"
        }), _createVNode(_component_el_table_column, {
          align: "center",
          label: "软件/游戏本地化"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            align: "center",
            prop: "chobitsPrice",
            label: "中翻母审"
          }), _createVNode(_component_el_table_column, {
            align: "center",
            prop: "femalePrice",
            label: "母翻中审"
          })]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          width: "150",
          align: "center",
          prop: "tranCertPrice",
          label: "证件翻译"
        }, {
          default: _withCtx(({
            $index
          }) => [$index == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_cache[0] || (_cache[0] = _createElementVNode("p", null, "50/份", -1)), _cache[1] || (_cache[1] = _createElementVNode("p", null, "适用于：身份证、户口本、出生医学证明、结婚证、驾驶证、财产证明、等级证书、成绩单、工作证明、财产证明、组织机构代码证、营业执照", -1))], 64)) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])]);
    };
  }
});